import $ from "jquery"
import Cookie from "js-cookie"
import Config from "../../js/global/Config"

class Chat {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("Chat::initialize()")

		$(document.body)
			.on("click", ".chat-collapsed", this._openChat.bind(this))
			.on("click", ".chat-minimize", this._closeChat.bind(this))
			.on("click", ".close-tooltip", this._closeChatTooltip.bind(this))

		this._initChat()

		if (!Cookie.get(Config.chatOptions.tooltipCookieName)) {
			window.setTimeout(() => {
				if (!$(".chat-open").is(":visible") && this._chatStatus) {
					$(".chat-indicator").show()
					$(".chat-tooltip").show()
				}
			}, 3000)
		}
	}

	_initChat() {
		livesupport.api.load(Config.chatOptions, (api) => {
			// refresh avaiability status (refresh time as set in variables)
			this._updateChatStatus(api)

			// set interval time for status refresh
			window.setInterval(() => {
				this._updateChatStatus(api)
			}, 5000)

			// handle chat start
			$(document.body).on("submit", ".bb-chat form", (e) => {
				e.preventDefault()
				this._chatStart($(e.currentTarget).closest("form"), api)
			})
		})
	}

	_updateChatStatus(api) {
		// get availability status
		api.acquireChatStatus(
			(chatStatus) => {
				this._chatStatus = chatStatus.status
				if (this._chatStatus) {
					$(".bb-chat").removeClass("offline")
				} else {
					$(".bb-chat").addClass("offline")
				}
			},
			function (e) {
				throw e
			}
		)
	}

	_chatStart($form, api) {
		const customerGender = $form.find("input[name='chat-customer-gender']").val()
		const customerFirstName = $form.find("#chat-customer-firstName").val()
		const customerLastName = $form.find("#chat-customer-lastName").val()
		// const customerTerms = $form.find("#chat-terms").val()
		// const customerHistory = $form.find("#chat-history").val()

		api.person.provideFirstName(customerFirstName).provideLastName(customerLastName).provideGender(customerGender)

		api.startChat(
			function () {
				// chat successfully started
				// eslint-disable-next-line no-console
				console.log("Chat started", api)
			},
			function (e) {
				// handle errors
				// eslint-disable-next-line no-console
				console.log("Chat start failed. ", e)
			}
		)
	}

	_openChat() {
		if (!Cookie.get(Config.chatOptions.tooltipCookieName)) {
			//Execute code that sets preference cookies
			if (window.Cookiebot && window.Cookiebot.consent.preferences) {
				Cookie.set(Config.chatOptions.tooltipCookieName, true, { path: "/" })
			}
		}

		if (this._chatStatus) {
			$(".chat-collapsed").hide()
			$(".chat-tooltip").hide()
			$(".chat-open").show()
		} else {
			$(".chat-tooltip").show()
		}
	}

	_closeChat() {
		$(".chat-tooltip").hide()
		$(".chat-open").hide()
		$(".chat-indicator").hide()
		$(".chat-collapsed").show()
	}

	_closeChatTooltip() {
		$(".chat-tooltip").hide()

		//Execute code that sets preference cookies
		if (window.Cookiebot && window.Cookiebot.consent.preferences) {
			Cookie.set(Config.chatOptions.tooltipCookieName, true, { path: "/" })
		}
	}
}

export default Chat
